export const STONE_COLORS: Record<number, { cardColor: string }> = {
  0: { cardColor: 'bg-[#46211C]' },
  1: { cardColor: 'bg-[#130033]' },
  2: { cardColor: 'bg-[#6E511A]' },
  3: { cardColor: 'bg-[#01391E]' },
  4: { cardColor: 'bg-[#BB4300]' },
  5: { cardColor: 'bg-[#012A34]' },
  6: { cardColor: 'bg-[#1E3944]' },
  7: { cardColor: 'bg-[#104062]' },
};
